import React, { useState } from 'react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState(-1);
  const toggleAccordion = index => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  const faqs = [{
    question: '¿A qué edad debo empezar a enseñar español a mis hijos?',
    answer: 'Lo ideal es comenzar desde el nacimiento, pero nunca es tarde para empezar. La guía incluye estrategias específicas para cada etapa, desde bebés hasta adolescentes. Cuanto antes comiences, más natural será el proceso de aprendizaje.'
  }, {
    question: '¿Qué hago si mi hijo/a se resiste a hablar español?',
    answer: 'La resistencia es normal y abordamos este tema específicamente en la guía. Ofrecemos estrategias para convertir el español en algo divertido y deseable, no en una obligación. El secreto está en encontrar motivaciones personalizadas y crear experiencias positivas con el idioma.'
  }, {
    question: '¿Funcionará si yo no hablo español perfectamente?',
    answer: '¡Absolutamente! La guía incluye recursos para padres con diferentes niveles de español. Lo importante es la consistencia, no la perfección. Incluso si solo conoces lo básico, puedes crear un entorno que apoye el bilingüismo de tus hijos.'
  }, {
    question: '¿Cuánto tiempo tomará ver resultados?',
    answer: 'Muchas familias notan cambios en las primeras semanas al implementar las estrategias. Sin embargo, el desarrollo del lenguaje es un proceso gradual. La guía incluye un plan de 30 días para comenzar a ver progreso medible, pero los beneficios completos se desarrollan con el tiempo y la consistencia.'
  }, {
    question: '¿Qué formato tiene la guía y los bonos?',
    answer: 'Todos los materiales son archivos PDF digitales que puedes leer en cualquier dispositivo: computadora, tablet o teléfono. Recibirás acceso inmediato después de la compra, sin esperar envíos físicos.'
  }, {
    question: '¿Ofrecen garantía de devolución?',
    answer: 'Sí, ofrecemos una garantía de satisfacción de 7 días. Si sientes que la guía no cumple con tus expectativas, simplemente contáctanos dentro de los primeros 7 días después de tu compra para un reembolso completo.'
  }];
  return <section className="py-12 bg-white" data-id="element-57">
      <div className="container mx-auto px-4" data-id="element-58">
        <div className="max-w-3xl mx-auto" data-id="element-59">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 text-center" data-id="element-60">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-61">
            {faqs.map((faq, index) => <div key={index} className={`border rounded-lg overflow-hidden ${openIndex === index ? 'border-orange-400' : 'border-gray-200'}`} data-id="element-62">
                <button className="w-full px-6 py-4 text-left flex justify-between items-center bg-white hover:bg-orange-50 transition-colors" onClick={() => toggleAccordion(index)} data-id="element-63">
                  <span className="font-medium text-lg" data-id="element-64">{faq.question}</span>
                  <svg className={`w-5 h-5 transform transition-transform ${openIndex === index ? 'rotate-180 text-orange-500' : 'text-gray-500'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-65">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-66" />
                  </svg>
                </button>
                {openIndex === index && <div className="px-6 py-4 bg-orange-50 border-t border-orange-100" data-id="element-67">
                    <p className="text-gray-700" data-id="element-68">{faq.answer}</p>
                  </div>}
              </div>)}
          </div>
          <div className="mt-10 text-center" data-id="element-69">
            <a href="#comprar" className="inline-block bg-orange-600 text-white px-6 py-3 rounded-md font-medium hover:bg-orange-700 transition-colors" data-id="element-70">
              Obtén Tu Guía Ahora
            </a>
          </div>
        </div>
      </div>
    </section>;
}